import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useEffect, useMemo, useRef } from 'react';
import { motion } from 'framer-motion';

import { useGetParams } from '../../hooks/useGetParams';

import Message from '../Message/Message';
import { BgVideo } from '../BgVideo/BgVideo';
import { StartBgVideo } from '../StartBgVideo/StartBgVideo';

import logo from '../../assets/images/logo.webp';
import left from '../../assets/images/left.png';
import right from '../../assets/images/right.png';

import styles from './MessagesList.module.css';

import confetti from '../../assets/video/confetti.webm';

export const MessagesList = ({
  messages,
  currentState,
  winId,
  speed,
  mode,
}) => {
  const confettiRef = useRef(null);

  const isWinner = useMemo(() => currentState === 'S5', [currentState]);

  const { authorFontSize, user } = useGetParams();

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current && isWinner) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, 1500);
    } else if (idTimeout) {
      clearTimeout(idTimeout);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [isWinner]);

  const letters = 'ПОБЕДИТЕЛЬ!'.split('').reverse();

  return (
    <div className={styles['wrapper']}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className={styles.logoBlock}
      >
        <img src={logo} alt="" className={styles.logo} />
      </motion.div>

      <motion.div
        initial={{ y: '30rem' }}
        animate={{ y: '-35rem' }}
        transition={{ duration: 1, delay: 0.5 }}
        className={styles.leftCupBlock}
      >
        <img src={left} alt="" />
      </motion.div>

      <motion.div
        initial={{ y: '40rem' }}
        animate={{ y: '-5rem' }}
        transition={{ duration: 1, delay: 0.5 }}
        className={styles.rightCupBlock}
      >
        <img src={right} alt="" />
      </motion.div>

      <div className={styles.firstLine} dir="rtl">
        {isWinner &&
          letters.map((l, idx, arr) => {
            let initialIdx = 5;
            let oneLetterWidth = 6;
            // let initialX = `${(idx - initialIdx) * oneLetterWidth * -1}rem`;
            let initialX = `${(idx - initialIdx) * oneLetterWidth}rem`;

            return (
              <motion.div
                style={{ position: 'relative', zIndex: idx * -1 }}
                key={l + idx}
                initial={{
                  scale: 0,
                  x: initialX,
                }}
                animate={{
                  scale: 1,
                  x: 0,
                }}
                transition={{
                  duration: 0.3,
                  delay: idx * 0.06 + 1.2,
                }}
              >
                {l}
              </motion.div>
            );
          })}
      </div>

      <div className={styles.messagesWrapper}>
        <TransitionGroup className={styles.messages}>
          {messages.length > 0 &&
            messages.map((item, i) => {
              const msg = mode === 'allMessages' ? item.message : item;
              const key =
                mode === 'allMessages'
                  ? item.id
                  : item.senderNumber + item.author;
              const currentId =
                mode === 'allMessages' ? item.id : item.senderNumber;

              return (
                <CSSTransition
                  key={item.UUID}
                  timeout={speed}
                  classNames="position"
                >
                  <Message
                    isWinner={isWinner}
                    winId={winId}
                    key={key}
                    message={msg}
                    authorFontSize={authorFontSize}
                    currentId={currentId}
                    user={user}
                  />
                </CSSTransition>
              );
            })}
        </TransitionGroup>
      </div>

      {isWinner && (
        <video
          ref={confettiRef}
          muted="muted"
          loop
          playsInline
          className={styles.confetti}
        >
          <source src={confetti} type="video/webm"></source>
        </video>
      )}

      <StartBgVideo />
      <BgVideo />
    </div>
  );
};
